import React from 'react';

// Simple SVG radar chart for 10 categories
export default function RadarChart({ data = [], size = 320, max = 10 }) {
  const cx = size / 2, cy = size / 2, r = size / 2 - 40;
  const n = data.length || 10;
  const angleStep = (Math.PI * 2) / n;

  const point = (i, val) => {
    const angle = -Math.PI / 2 + i * angleStep;
    const dist = (val / max) * r;
    return [cx + Math.cos(angle) * dist, cy + Math.sin(angle) * dist];
  };

  const gridLevels = [0.25, 0.5, 0.75, 1];
  const dataPoints = data.map((d, i) => point(i, d.value));
  const path = dataPoints.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p[0]} ${p[1]}`).join(' ') + ' Z';

  return (
    <svg viewBox={`0 0 ${size} ${size}`} className="w-full h-auto">
      {gridLevels.map(lvl => (
        <polygon key={lvl}
          points={Array.from({ length: n }, (_, i) => point(i, lvl * max).join(',')).join(' ')}
          fill="none" stroke="#e2e8f0" strokeWidth={1} />
      ))}
      {Array.from({ length: n }, (_, i) => {
        const [x, y] = point(i, max);
        return <line key={i} x1={cx} y1={cy} x2={x} y2={y} stroke="#e2e8f0" strokeWidth={1} />;
      })}
      <path d={path} fill="rgba(56, 189, 248, 0.18)" stroke="#0284c7" strokeWidth={2} strokeLinejoin="round" />
      {dataPoints.map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r={3.5} fill="#0284c7" stroke="#ffffff" strokeWidth={1.5} />
      ))}
      {data.map((d, i) => {
        const [x, y] = point(i, max + 1.4);
        return (
          <text key={i} x={x} y={y} textAnchor="middle" dominantBaseline="middle"
            fill="#475569" fontSize={10} fontFamily="Inter, sans-serif">
            {d.short || d.label}
          </text>
        );
      })}
    </svg>
  );
}
